import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface putAlarmProfilesResult {
  success: boolean;
  body?: any;
  error?: string;
  status?: number;
}

export const putAlarmProfilesUseCase = async (
  payload: any,
): Promise<putAlarmProfilesResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const sourceId = store.getState().yourSlice.connectionView.source.source_id;

    const response = await apiUseCases.putAlarmProfilesAPI(
      namespace,
      sourceId,
      payload,
    );

    return {
      success: true,
      body: response.data,
      status: response.status,
    };
  } catch (error) {
    const { message, status } = parseAxiosApiError(
      error,
      "Failed to update alarm profiles",
    );
    return {
      success: false,
      error: message,
      status,
    };
  }
};
